
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { StringFilterPipe } from '../../../pipes';
import { AppStateHolder } from '../../../shared';
import { UserActivitiesService } from './user-activities.service';

@Component({
    selector: 'calendar-search-typology',
    templateUrl: 'search-typology.component.html',
    host: {
        '(document:click)': 'handleClick($event)'
    },
    standalone: true,
    imports: [FormsModule, StringFilterPipe, TranslateModule]
})

export class SearchTypologyComponent implements OnInit {
  appStateHolder = inject(AppStateHolder);
  private service = inject(UserActivitiesService);


  findTypologies: any[];

  private _calendar: any;
  @Output() selected: EventEmitter<any> = new EventEmitter();
  @Input() field: string;

  typologies: any[];

  term: string;
  status: string = 'ok';

  showResult: boolean = false;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
  }

  ngOnInit(): void {
    this.findTypologies = null;
    this.status = 'busy';

    this.service
      .getActivityTypologies()
      .subscribe(result => {
        this.typologies = result;
        this.status = 'ok';
      });
  }

  handleClick(event) {
    this.findTypologies = null;
  }

  show() {
    this.showResult = true;
  }

  onSelectTypology(typology): void {

    this.selected.next(typology);
  }
}
